var map = {
	"./arrow-down-red.svg": "bedc",
	"./contact-qa-red.svg": "4d3e",
	"./icon/check-red.svg": "7c82",
	"./loading-red.svg": "3114",
	"./order-question-red.svg": "100b",
	"./question-red.svg": "799d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fec8";